export const EyeClosedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 10.8891L15.6 9.02246" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M3 10.8891L4.4 9.02246" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M11.6001 13.6114L11.2112 11.667" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M8.2998 13.6114L8.68869 11.667" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M5.3999 12.3667L6.33324 10.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M14.6001 12.3667L13.6668 10.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    <path
      d="M3 7L3.47595 7.67479C6.72591 12.2825 13.5951 12.1722 16.6955 7.46259L17 7"
      stroke="black"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
)
